<template>
  <div>
    <h3>Leaderboard</h3>
    <div v-if="isLoading"  class="spinner-grow text-light" role="status">
  <span class="visually-hidden">Loading...</span>
</div>
    <div v-else-if="topScores.length > 0" class="top-scores-list">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Rank</th>
            <th>Username</th>
            <th>Score</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(score, index) in visibleScores" :key="index">
            <td>
              <span v-if="index == 0">🥇</span>
              <span v-else-if="index == 1">🥈</span>
              <span v-else-if="index == 2">🥉</span>
              <span v-else>{{ index + 1 }}</span>
            </td>
            <td><span v-if="index == 0">🏆&nbsp;</span>{{ score.username }}</td>
            <td>{{ score.score }}</td>
          </tr>
        </tbody>
      </table>

      <!-- Show More Link -->
      <div v-if="topScores.length > 3 && !showMore">
        <button class="btn btn-link" @click="toggleShowMore">Show More</button>
      </div>
      <div v-if="showMore && topScores.length > 3">
        <button class="btn btn-link" @click="toggleShowMore">Show Less</button>
      </div>
    </div>

    <div v-else>
      <p>No scores yet.</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: "Scoreboard",
  data() {
    return {
      showMore: false, // Track if the user wants to see more scores
    };
  },
  mounted() {
    this.$store.dispatch("fetchTopScores");
  },
  computed: {
    ...mapState(['isLoading']), // Map isLoading state from Vuex store
    topScores() {
      return this.$store.getters.topScores; // Access top scores from Vuex store
    },
    visibleScores() {
      // If showMore is true, show all scores, otherwise show the top 3
      return this.showMore ? this.topScores : this.topScores.slice(0, 3);
    },
  },
  methods: {
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
  },
};
</script>

<style scoped>
.top-scores-list {
  margin-top: 20px;
}

.table th,
.table td {
  text-align: center;
}

.table th {
  background-color: #f4f4f4;
}

.table-striped tbody tr:nth-child(odd) {
  background-color: #f9f9f9;
}

.btn-link {
  text-decoration: none;
  cursor: pointer;
}
</style>
